import "./IInvestStoreViewComponent.scss";
import {IComponentOptions, IScope} from "angular";
import {IInvestStoreViewStore} from "../service/IInvestStoreViewStore";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {StoreStateParams} from "../../common/models/StoreStateParams";
import {IInvestStoreService} from "../service/IInvestStoreService";
import {StateService} from "@uirouter/core";
import {StoreController} from "../../common/controllers/StoreController";
import {IInvestProductMappings, IInvestStoreProduct} from "../models/IInvestStoreProduct";

export const StoreView = "iinvestStore";

export function storeView(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/view/IInvestStoreViewComponent.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: IInvestStoreViewComponentController
    };
}

export class IInvestStoreViewComponentController extends StoreController<IInvestStoreProduct> {

    public viewStore: IInvestStoreViewStore;

    /** @ngInject */
    public constructor($scope: IScope,
                       iinvestStoreService: IInvestStoreService,
                       currentUserService: CurrentUserService,
                       $stateParams: StoreStateParams<IInvestStoreProduct>,
                       $state: StateService,
                       simpleModalService: any) {
        super($scope, iinvestStoreService, currentUserService, $stateParams, $state,
            IInvestProductMappings, simpleModalService);
    }
}
